import React from "react";
import { LegalPage } from "./legal/LegalPage";

const ContratoPJ = () => <LegalPage namespace="legalContratoPJ" />;

export default ContratoPJ;
